export default {
  buttons: {
    go_to_basket: 'Ir al carrito',
  },
};
